// removed by extract-text-webpack-plugin
module.exports = {"Container":"main__Container__3RxaQ","Image":"main__Image__3P7g1","Banner":"main__Banner__L11Km","Particles":"main__Particles__2Xt3C","Section":"main__Section__27X1k"};


//////////////////
// WEBPACK FOOTER
// ./src/Routes/main.css
// module id = 1753
// module chunks = 2